import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CORE_TRIGGER_RULE_URL } from '../../constants/urls';
import TriggerRuleType from '../../domain/triggerRule';

// This could be renamed to 'cascade_core_trigger_rules'
// and take a 'force_update' parameter if the backend was changed to accept it.
function addNewCoreTriggerRules(teamToFilter: number, filterToFcpIds?: number[]) {
  const requestConfig = {
    params: {
      team: teamToFilter,
      fcps: filterToFcpIds
    },
  } as AxiosRequestConfig;
  const EMPTY_DATA_OBJECT = {};
  return axios.post<any, AxiosResponse<TriggerRuleType[]>>(
    `${CORE_TRIGGER_RULE_URL}/cascade/`,
    EMPTY_DATA_OBJECT,
      requestConfig
  );
}

export {addNewCoreTriggerRules}